import { client } from '@/common-utils/libraries/axios/axios';
import PAYLUDD_SUBSCRIPTIONS from '../apiUrls';
import { replaceParameters } from '@/common-utils/functions/restUtils';

const mutationSummarizeEmergencyRemoteCollectionTransactions = (onSuccess, onError) => {
    return {
        mutationFn: ({ posTerminalId, transactionsList }) => {
            return client.post((replaceParameters(PAYLUDD_SUBSCRIPTIONS.EMERGENCY_REMOTE_COLLECTION_TRANSACTIONS_SUMMARY.url, { uuid: posTerminalId })),
                { transactionsList: transactionsList });
        },
        // onError: (error, variables, context)
        onError: (error) => {
            onError(error);
        },
        // onSuccess: (data, variables, context)
        onSuccess: (data) => {
            onSuccess(data);
        },
        // onSettled: (data, error, variables, context)
        onSettled: () => {
            // Error or success... doesn't matter!
        }
    };
};

export default mutationSummarizeEmergencyRemoteCollectionTransactions;